import React, { useState, useEffect, useMemo } from "react";
import { exams, exams as examsApi } from "../../../api/exams";
import { useTranslation } from 'react-i18next';
import Loader from "../../../components/loader/Loader";
import Pagination from "../../../components/Pagination/Pagination";
import Input from "../../../components/input/Input";
import EmptyData from "../../../components/EmptyData";
import SurveyCard from "../dashboard/components/SurveyCard";
import { useMutation, useQuery } from "react-query";
import Card from "../dashboard/components/Card";
import { UpdatedRequestTable } from "../../../components/table/RequestTable";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearFlaggedQuestion } from "../../../features/candidate-exam/candidate-exam-slice";
import { api } from "../../../api";
import toast from "react-hot-toast";
const Reviews = ({ width }) => {
  const storedBranding = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("branding"));
    } catch (error) {
      return null;
    }
  }, []);
  const appearance = storedBranding?.data?.appearance;

  const [showRedirect, hideRedirect] = useState(false);
  const user = JSON.parse(sessionStorage.getItem('user'))
  const { t, i18n: i18nNext, } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(30);
  const [search, setSearch] = useState('')
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { isLoading: reviewsLoading, data: reviews } = useQuery(
    ["reviews", currentPage, perPage, search],
    async () => {
      const data = await examsApi.getReviews({
        type: null, id: user?.user?.user_id, currentPage, perPage, search
      });
      return data;
    },
    {
      select: (data) => data,
      refetchOnWindowFocus: false,
    }
  );

  const { data: summary, isLoading: summaryLoading } = useQuery(
    ["Summary Data"],
    async () => {
      const data = await api.getReviwerSummary(user?.user?.user_id);
      return data;
    },
    {
      select: (response) => response?.data,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    }
  );

  const startSurvey = (data) => {
    const questionResponse = data?.data?.questions
    sessionStorage.setItem('survey-questions', JSON.stringify(questionResponse))
    sessionStorage.setItem('survey-user', 'employee')
    navigate('/candidate/survey')
  }

  const getReviewerQuestionsmutation = useMutation(exams.getReviewerExamQuestionsv2, {
    onSuccess: async (data) => {
      startSurvey(data)
    }
  })

  const takeSurvey = (exam) => {
    if (/*parseInt(exam?.progress) >= 100 ||*/ /*exam?.completed_at */ false) return toast.error('You have already completed this survey');
    // else if(new Date(exam?.end_date).getTime() < new Date().getTime()) return toast.error('This survey has been closed');
    dispatch(clearFlaggedQuestion(''));
    window.sessionStorage.setItem("assessment-type", "review");
    window.sessionStorage.setItem("active-assessment-id", exam?.user_exam_id);
    window.sessionStorage.setItem("active-assessment-user-id", exam?.user_id);
    window.sessionStorage.setItem("active-assessment", JSON.stringify(exam));
    getReviewerQuestionsmutation.mutate({
      reviewerId: user?.user?.user_id || window.sessionStorage.getItem("user_id"),
      userId: exam?.user_id,
      userExamId: exam?.user_exam_id,
    });
  }

  let columns = useMemo(
    () => [
      {
        title: t('id'),
        selector: null,
        key: "id",
        render: ({ index }) =>
          index +
          1 +
          ((reviews?.meta?.current_page || 1) - 1) *
          (reviews?.meta?.per_page || perPage),
      },
      {
        title: 'Evaluation',
        selector: "survey_title",
        key: "survey_title",
        render: ({ item, row }) => {
          return (
            <button
              className="text-baseFont"
              onClick={() => handleActionClick(row)}
            >
              {item}
            </button>
          );
        },
      },
      {
        title: 'Type',
        selector: "review_type",
        key: "review_type",
        render: ({ item }) => {
          return (
            <button className="text-baseFont">
              {item}
            </button>
          );
        },
      },
      {
        title: 'Participant',
        selector: "user_name",
        key: "user_name",
        render: ({ item, row }) => {
          return (
            <button className="text-baseFont">
              {item}
            </button>
          );
        },
      },
      {
        title: 'Due Date',
        selector: "end_date",
        key: "end_date",
        render: ({ item }) => {
          return <span>{`${new Date(item).toLocaleDateString('en-ng')}`}</span>
        }
      },
      {
        title: 'Progress',
        selector: "progress",
        key: "progress",
        render: ({ item, row }) => {
          return <div className="w-[80px]">
            <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
              <div style={{ width: `${parseInt(row?.progress)}%`, backgroundColor: appearance?.theme_colour }} className="h-full bg-primary"></div>
            </div>
          </div>
        }
      },
      {
        title: 'Status',
        selector: null,
        key: null,
        render: ({ row }) => {
          return <div className="flex items-center gap-2">
            {
              parseInt(row?.progress) === 0 ?
                <span className="bg-gray-100 w-[100px] text-center text-gray-700 font-medium px-2 py-1 text-sm lg:text-base rounded-full">
                  Not Started
                </span>
                :
                ( /*parseInt(row?.progress) === 100 ||*/ row?.completed_at) ?
                  <span className="bg-green-100 w-[100px] text-center text-green-600 font-medium px-2 py-1 text-sm lg:text-base rounded-full">
                    Completed
                  </span>
                  :
                  <span className="bg-orange-100 w-[100px] text-center text-orange-500 font-medium px-2 py-1 text-sm lg:text-base rounded-full">
                    In Progress
                  </span>
            }
          </div>
        }
      },
      {
        title: t('action'),
        selector: null,
        key: null,
        render: ({ item, row }) => {
          return <button
            className={`rounded-full text-white py-2 px-5 text-sm lg:text-base
                        ${(/*parseInt(row?.progress) === 100 ||*/ row?.completed_at) ? 'bg-gray-400' : 'bg-orange-500'}
                       `}
            style={{
              backgroundColor: (!(/*parseInt(row?.progress) === 100 ||*/ row?.completed_at) && appearance?.theme_colour) ? appearance.theme_colour : undefined
            }}
            onClick={() => takeSurvey(row)}
          >
            {
              (/*parseInt(row?.progress) === 100 ||*/ row?.completed_at) ? 'Completed' : parseInt(row?.progress) === 0 ? 'Evaluate' : 'Continue'
            }
          </button>
        }
      },
    ], [reviews?.meta?.current_page, reviews?.meta?.per_page, perPage, appearance])

  return (
    <React.Fragment>
      {(
        <>
          {/*( showRedirect && mockAssessment?.length) ? 
               <Redirect handleRedirect={hideRedirect} /> : null 
           */}
          <h1
            className="text-white rounded-lg shadow bg-primary py-4 px-3 font-semibold"
            style={{ fontSize: "20px", marginTop: "0px", backgroundColor: appearance?.theme_colour }}
          >
            Evaluations
          </h1>
          <p className="text-gray-600 text-lg mt-2">
            Track your evaluation status and review feedback recieved.
          </p>
          <div className="mb-12 mt-5 justify-between grid gap-5 grid-cols-1 md:grid-cols-3">
            <Card
              title={'Assigned'}
              text={summary?.assigned || 0}
              color="text-gray-900"
              bgColor={'bg-white'}
              isLoading={false}
              description={'Total evaluations assigned to you'}
              width="w-full"
            />
            <Card
              title={'Pending'}
              text={summary?.pending || 0}
              isLoading={false}
              bgColor={'bg-orange-50'}
              color="text-orange-500"
              description={'Evaluations yet to be completed'}
              width="w-full"
            />
            <Card
              title={'Completed'}
              bgColor={'bg-green-50'}
              text={summary?.completed || 0}
              isLoading={false}
              color="text-[#87AA4B]"
              description={'Total evaluations completed'}
              width="w-full"
            />
          </div>
          <div
            className="mt-1 gap-4"
            style={{
              display: "flex",
              width: "100%",
              // gridTemplateColumns: width > 768 ? "4fr 1.5fr" : "1fr",
              //  border: "1px solid #ccc",
            }}
          >
            <div className="w-full md:pt-0">
              <section>
                {/*<div className="md:flex hidden max-[500px]:p-2 items-center justify-between mb-3">
                      <h5 className="max-[500px]:mb-3 text-white md:py-5 px-3 rounded-xl text-xl font-semibold">
                         My Reviews
                      </h5>
                      <div className="w-full md:w-[300px] mr-3 text-slate-950">
                          <Input 
                            type='search'
                            placeholder={'Search reviews'}
                            onChange={ event => setSearch(event.target.value)}
                          />
                    </div>
                    </div>*/}
                {
                  reviewsLoading ? (
                    <Loader />
                  ) :
                    !reviews?.data?.length > 0 ? (
                      <EmptyData text={'No Reviews Found'} />
                    ) :
                      <>
                        <div className="mb-12 sm:hidden grid pt-4 mt-4 gap-5 grid-cols-1 md:grid-cols-3">
                          {
                            reviews?.data?.map((survey, index) => (
                              <SurveyCard survey={survey} key={survey?.id} />
                            ))
                          }
                        </div>
                        <div className='max-[500px]:hidden shadow rounded-lg bg-white p-5'>
                          <h5 className="text-xl pb-3 border-b text-orange-500 font-medium" style={{ color: appearance?.theme_colour }}>Evaluations awaiting your input</h5>
                          <UpdatedRequestTable
                            columns={columns}
                            data={reviews?.data}
                            isLoading={reviewsLoading}
                          />
                        </div>
                      </>

                }
              </section>
              <Pagination
                data={reviews?.meta}
                perPage={perPage}
                pageNo={currentPage}
                setPageNo={setCurrentPage}
                setPerPage={setPerPage}
              />
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default Reviews;
